export const multiLineEllipsis = (lines: number): object => ({
  display: "-webkit-box",
  "-webkit-line-clamp": lines,
  "-webkit-box-orient": "vertical",
  overflow: "hidden",
  whiteSpace: "pre-line",
});
